<template>
  <div class="mine p_b">
    <div class="top_por d_f ali_c j_c">
      <div>
        <div class="por">
          <van-image fit="cover" :src="info.headImge"/>
        </div>
        <div class="name">{{info.nickname}}</div>
      </div>
    </div>
    <ul class="nav">
      <li @click="$router.push('/Intro?code=gywm')">
          关于我们   <span>查看 <van-icon name="arrow" /></span>
      </li>
      <li style="margin-top:8px;"  @click="$router.push('/ContactUs')">
          联系我们   <span>导航 <van-icon name="arrow" /></span>
      </li>
    </ul>
    <FootTab :ac="3"></FootTab>
  </div>
</template>

<script>
  export default {
    name: "Mine",
    data() {
      return {
        info:{},
      }
    },
    created(){
      this.getUserInfo()
    },
    methods: {
      getUserInfo(){
        this.$api.getUserInfo().then(res => {
          this.info = res.data;
        })

      },
    }
  }
</script>

<style scoped lang="scss">
  .m_c{
    .ab_us{
      .d_f{
        .right{
          margin-right: 0;
          height: 12px;
          width: 11px;
        }
        img{
          width: 17px;
          height: 17px;
          margin-right: 12px;
        }
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        padding: 0 8px 0 11px;
        height: 47px;
        line-height: 47px;
        border-bottom: 1px solid #E6E6E6;
      }
      background: #FFFFFF;
      border-radius: 5px;
      padding-bottom: 48px;
    }
    .order{
      .item{
        .items{
          img{
            height: 21px;
            width: auto;
            margin-bottom: 6px;
          }
          font-size: 14px;
          font-weight: 500;
          color: #3F3F3F;
          cursor: pointer;
        }
        text-align: center;
        padding: 26px 10px 22px 10px;
      }
      .ot{
        .d_f{
          img{
            width: 5px;
            height: 9px;
            margin-left: 3px;
          }
          font-size: 10px;
          font-weight: 500;
          color: #ADADAD;
        }
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        height: 37px;
        line-height: 27px;
        border-bottom: 1px solid #D6D6D6;
      }
      margin-bottom: 16px;
      padding: 0 6px;
      background: #FFFFFF;
      border-radius: 5px;
      box-shadow: #25BDDE 0 0 10px 3px;
    }
    padding: 0 13px;
    top: -37px;
  }
  .top_por{
    .por{
      width: 90px;
      height: 90px;
      border: 5px solid #fb8362;
      box-shadow: 0 0 5px 2px rgba(255, 133, 100, 0.71);
      border-radius: 50%;
      box-sizing: border-box;
      overflow: hidden;
      margin-bottom: 8px;
    }
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    height: 354px;
    background: url("../assets/images/pic3.png") no-repeat;
    background-size: 100% 100%;
  }
  .mine{
    background-color: #F0F0F0;
  }
  .nav li{
    position: relative;
    width: 345px;
    height: 121px;
    line-height: 121px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    padding-left: 20px;
    background: url('../assets/images/nav1.png') no-repeat center;
    background-size: 100% 100%;
    margin: -25px auto 0;

    &:last-child{
      background: url('../assets/images/lxwm_bg.png') no-repeat center;
      background-size: 100% 100%;

    }
    span{
      position: absolute;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.79);
      right: 20px;
      top: 50%;
      line-height: 14px;
      margin-top: -7px;
    }
  }
</style>
